
import { PermissionList, RolePermission } from 'utils/hooks/rolePermissions';

export const canManageTags = () => RolePermission([PermissionList.TAG_MANAGE?.code]);

export const canReadTags = () => RolePermission([PermissionList.TAG_READ?.code, PermissionList.TAG_MANAGE?.code]);

export const getTagId = (tag) => (typeof tag === 'string' ? tag : tag?._id || tag?.id);

export const getAssignedTagIds = (entity) => (entity?.tags || []).map(getTagId).filter(Boolean).map(String);
